import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UniStepperComponent } from "@universal-ui";
import { Subject } from "rxjs";
import { map } from "rxjs/operators";

import { Unsubscriber } from "@shared/Components/Unsubscriber/unsubscriber.component";

import { CanalesService } from "../../Shared/Services/canales.service";
import { Fideicomiso, NewUserAccessData, NewUserFiduciary, NewUserPersonalData } from "../../Shared/Types/new-user";

@Component({
  selector: "app-edit-user-fiduciary",
  templateUrl: "./edit-user-fiduciary.component.html",
})
export class EditUserFiduciaryComponent extends Unsubscriber implements OnInit {
  public newUser: NewUserFiduciary | null = null;
  public resetForm: Subject<boolean> = new Subject();
  public isOperative: boolean;
  @ViewChild("stepper") public stepper: UniStepperComponent;

  public currentUserID: number;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly canalesService: CanalesService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.isOperative = this.router.url.includes("editar-usuario-fiduciaria/operational");
    const id = this.route.snapshot.params.id;
    this.anotherSubscription = this.canalesService
      .getUserFiduciary(id)
      .pipe(
        map((user) => {
          this.currentUserID = user.id;
          return this.canalesService.mapFromUserToNewUserFiduciary(user);
        })
      )
      .subscribe((newUser) => {
        this.newUser = newUser;
      });
  }

  public onSubmitPersonalData(personalData: NewUserPersonalData): void {
    this.newUser = { ...this.newUser, ...personalData };
  }

  public onSubmitAccessData(accessData: NewUserAccessData): void {
    this.newUser = { ...this.newUser, ...accessData };
    this.stepper.next();
  }

  public onSummit(fideocomisos: Fideicomiso): void {
    this.newUser = { ...this.newUser, escrows: fideocomisos };

    this.anotherSubscription = this.canalesService.editUserFiduciary(this.newUser, this.currentUserID).subscribe(() => {
      this.stepper.next();
    });
  }

  public onReset(): void {
    this.newUser = null;
    this.stepper.reset();
  }

  public onBack(): void {
    this.stepper.previous();
  }
}
